export default "__VITE_ASSET__CH4tdo4L__"